/**
 * Likes de productos por negocio (localStorage del cliente).
 * Clave: soluqr_liked_products_${businessId} → string[]
 */

function storageKey(businessId) {
  return `soluqr_liked_products_${String(businessId || '').trim()}`;
}

export function getLikedProductIds(businessId) {
  const bid = String(businessId || '').trim();
  if (!bid || typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(storageKey(bid));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    const out = [];
    const seen = new Set();
    for (const item of parsed) {
      const id = String(item ?? '').trim();
      if (!id || seen.has(id)) continue;
      seen.add(id);
      out.push(id);
    }
    return out;
  } catch {
    return [];
  }
}

export function isProductLiked(businessId, productId) {
  const pid = String(productId || '').trim();
  if (!pid) return false;
  return getLikedProductIds(businessId).includes(pid);
}

/** @returns {{ liked: boolean, ids: string[] }} */
export function toggleLikedProduct(businessId, productId) {
  const bid = String(businessId || '').trim();
  const pid = String(productId || '').trim();
  if (!bid || !pid) return { liked: false, ids: getLikedProductIds(businessId) };

  const current = getLikedProductIds(bid);
  const set = new Set(current);
  let liked;
  if (set.has(pid)) {
    set.delete(pid);
    liked = false;
  } else {
    set.add(pid);
    liked = true;
  }
  const ids = Array.from(set);
  try {
    localStorage.setItem(storageKey(bid), JSON.stringify(ids));
  } catch {
    /* ignore quota */
  }
  return { liked, ids };
}
